import { useEffect, useState } from "react";
import { convertNumberToDecimal, getConformalValue, getStatsCellColor } from "../../../utils/formattingFns";

export default function ScoreValue({
    value,
    threshold,
}: {
    value: number | string | number[],
    threshold: number | null,
}) {
    const [ color, setColor ] = useState('#E0E0E0');
    const [ valueLabel, setValueLabel ] = useState('');

    useEffect(() => {
        if (threshold !== null && threshold !== undefined && Array.isArray(value)) {
            const { color, label } = getConformalValue(value as number[], threshold);
            setColor(color);
            setValueLabel(label);
        } else {
            setColor(getStatsCellColor({ min: 0, max: 1 }, Number(value), false));
        }

    }, [threshold, value]);


    return (
        <div style={{backgroundColor: color}} className="flex justify-center items-center gap-2 py-1 px-3 text-default font-semibold text-[12px] rounded-lg">
            {threshold !== null && threshold !== undefined && valueLabel ? (
                valueLabel
            ) : (
                convertNumberToDecimal(value as string | number)
            )}
        </div>
    )
}